export default "__VITE_ASSET__DtlHdDJF__"